import React from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import { AlertMessageProps } from "../../types";

const AlertMessage: React.FC<AlertMessageProps> = ({
  open,
  onClose,
  title,
  message,
  severity = "info",
  sx = {},
}) => {
  return (
    <Box sx={{ mb: 2, ...sx }}>
      <Collapse in={open}>
        <Alert
          severity={severity}
          action={
            onClose ? (
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={onClose}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            ) : null
          }
          sx={{
            borderRadius: 2,
            "& .MuiAlert-icon": {
              alignItems: "center",
            },
          }}
        >
          {title && <AlertTitle>{title}</AlertTitle>}
          {message}
        </Alert>
      </Collapse>
    </Box>
  );
};

export default AlertMessage;
